<template>
	<select @change='change' v-model="selected" class='form-control my-control table-control'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const ACT_INFO = 'get_act_info.php'
	const LPO_REASON = 'get_lpo_reason.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'lpoReason',
		data: function () { 
			return {
				selected: '2',
				options: []
			}
		},
		methods: {
			change () {
				EventBus.$emit(`edit_lpo_reason`, this.selected)
			}
		},
		created: function () {
			fetch(DB + ACT_INFO + '?id=' + this.$route.params.id, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				return res[0].f_88
			})
			.then(id => {
				fetch(DB + LPO_REASON, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.options = data
						this.selected = id ? id : data[0].id
					}
					else {
						this.options = []
					}
				})
				.catch(err => console.log(err))
			})
			.catch(err => console.log(err))
		}
	}
</script>


// WEBPACK FOOTER //
// lpoReason.vue?02a033f8